import lib from '@/library'
import config from '@/config'

let marketGroupDefaultProperties = {
  events: [],
  idfwmarketgroup: 'recommended'
}
let eventMarketGroupDefaultProperties = {
  idfwmarkettypeclassgroup: 'recommended',
  name: 'Recommended'
}

const state = {
  recommendedEventIds: [],
  recommendedMarketsIds: null,
  recommendedEventsMarketGroup: marketGroupDefaultProperties,
  recommendedMarketsEventMarketGroup: Object.assign({}, eventMarketGroupDefaultProperties),
  recommendedEventsLoading: config.app.autoconf.PLAYER_PERSONALISATION.enableRecommendedEvents || false,
  recommendedMarketsLoading: config.app.autoconf.PLAYER_PERSONALISATION.enableRecommendedMarkets || false,
  resetTimeoutIntervalOnLogin: false,
  recommendedEventsTabActive: false,
  recommendedMarketsTabAcvtive: false
}

const getters = {
  getRecommendedEventIds (state) {
    return state.recommendedEventIds
  },
  getRecommendedEventsMarketGroup (state) {
    return state.recommendedEventsMarketGroup
  },
  getRecommendedMarketsIds (state) {
    return state.recommendedMarketsIds
  },
  getRecommendedMarketsEventMarketGroup (state) {
    return state.recommendedMarketsEventMarketGroup
  },
  getRecommendedEventsLoading (state) {
    return state.recommendedEventsLoading
  },
  getRecommendedMarketsLoading (state) {
    return state.recommendedMarketsLoading
  },
  getResetTimeoutIntervalOnLogin (state) {
    return state.resetTimeoutIntervalOnLogin
  },
  getRecommendedEventsTabActive (state) {
    return state.recommendedEventsTabActive
  },
  getRecommendedMarketsTabAcvtive (state) {
    return state.recommendedMarketsTabAcvtive
  }
}

const mutations = {
  setRecommendedEventIds (state, data) {
    state.recommendedEventIds = data
  },
  setRecommendedEventsMarketGroup (state, data) {
    state.recommendedEventsMarketGroup = data
  },
  setRecommendedMarketsIds (state, data) {
    state.recommendedMarketsIds = data
  },
  setRecommendedMarketsEventMarketGroup (state, data) {
    state.recommendedMarketsEventMarketGroup = data
  },
  setRecommendedEventsLoading (state, data) {
    state.recommendedEventsLoading = data
  },
  setRecommendedMarketsLoading (state, data) {
    state.recommendedMarketsLoading = data
  },
  setResetTimeoutIntervalOnLogin (state, data) {
    state.resetTimeoutIntervalOnLogin = data
  },
  setRecommendedEventsTabActive (state, data) {
    state.recommendedEventsTabActive = data
  },
  setRecommendedMarketsTabAcvtive (state, data) {
    state.recommendedMarketsTabAcvtive = data
  }
}

const actions = {
  fetchRecommendedMarkets (context, eventId) {
    let userId = (localStorage.customer === 'undefined' ? null : localStorage.customer)
    return lib.rpcService.callBroker('personalization', 'getrecommendedmarkets', {
      'eventId': eventId,
      'uid': userId
    }).then(response => {
      if (response && response.result && response.result.eventmarketgroups && response.result.eventmarketgroups.length) {
        let eventMarketGroup = Object.assign({}, eventMarketGroupDefaultProperties)
        Object.assign(eventMarketGroup, response.result.eventmarketgroups[0])
        eventMarketGroup.idfwmarkettypeclassgroup = 'recommended'
        context.commit('setRecommendedMarketsEventMarketGroup', eventMarketGroup)
      } else {
        context.commit('setRecommendedMarketsEventMarketGroup', eventMarketGroupDefaultProperties)
      }
    }).catch((error) => {
      console.error(error)
      context.commit('setRecommendedMarketsEventMarketGroup', eventMarketGroupDefaultProperties)
    }).finally(() => {
      context.commit('setRecommendedMarketsLoading', false)
    })
  },
  fetchRecommendedEvents (context, userId) {
    return lib.rpcService.callBroker('personalization', 'getrecommendedevents', {
      'uid': userId
    }).then(eventIdsResponse => {
      if (eventIdsResponse.result) {
        context.commit('setRecommendedEventIds', eventIdsResponse.result)
        lib.kansas.psFavEvents({csvlist: eventIdsResponse.result}).then((eventsResponse) => {
          if (eventsResponse && eventsResponse.data && eventsResponse.data.events && eventsResponse.data.events.length) {
            let marketGroup = Object.assign({}, marketGroupDefaultProperties)
            Object.assign(marketGroup, eventsResponse.data)
            marketGroup.events.forEach((ev) => {
              if (ev.tsstart && ev.tsstart.indexOf('T') > -1) {
                ev.tsdate = ev.tsstart.split('T')[0]
              } else {
                ev.tsdate = '0'
              }
            })
            context.commit('setRecommendedEventsMarketGroup', marketGroup)
          } else {
            context.commit('setRecommendedEventsMarketGroup', marketGroupDefaultProperties)
          }
        }).catch((error) => {
          console.log(error)
          context.commit('setRecommendedEventsMarketGroup', marketGroupDefaultProperties)
        }).finally(() => {
          context.commit('setRecommendedEventsLoading', false)
        })
      } else {
        context.commit('setRecommendedEventIds', [])
        context.commit('setRecommendedEventsMarketGroup', marketGroupDefaultProperties)
        context.commit('setRecommendedEventsLoading', false)
      }
    }).catch((error) => {
      console.log(error)
      context.commit('setRecommendedEventIds', [])
      context.commit('setRecommendedEventsMarketGroup', marketGroupDefaultProperties)
      context.commit('setRecommendedEventsLoading', false)
    }).finally(() => {
      context.commit('setResetTimeoutIntervalOnLogin', false)
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/sports/recommended.js